import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "types/store";
import moment from "moment";
import { Button, ButtonGroup, Icon } from "aible";
import Select from "react-select";
import styles from "./style.module.css";
import { isEnabled } from "@/utils/featureFlags";
import ChatGPT from "components/ChatGPT/ChatGPT";
import { AgentC } from "components/Templates/AgentC";
import * as viewReducer from "@/containers/View/reducer";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";
import * as aibleAnywhereReducer from "@/containers/AibleAnywhere/reducer";
import * as accountsReducer from "@/containers/Accounts/reducer";
import * as globalReducer from "@/containers/App/reducer";
import { CHATAIBLE_AGENT_C } from "containers/ChatGPT/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import { SkillsOverview } from "@/components/AibleAgent/AibleAgent";
import { StandardOptions, TaggingOptions } from "@/components/Openshell/SandboxWorkList";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import MarkdownPanel from "../ChatGPT/MarkdownPanel";
var ClawViewMode;
(function (ClawViewMode) {
    ClawViewMode["ACTIVITY"] = "CLAW_ACTIVITY";
    ClawViewMode["MONITORING"] = "CLAW_MONITORING";
    ClawViewMode["TESTING"] = "CLAW_TESTING";
})(ClawViewMode || (ClawViewMode = {}));
const ClawView = ({ match, agentIdOverride }) => {
    const dispatch = useDispatch();
    const agentId = agentIdOverride !== undefined ? agentIdOverride : match?.params?.agentId;
    const clawAgent = useSelector((state) => aibleAnywhereReducer.getAibleAnywhere(state, agentId));
    const viewType = match?.params?.viewType;
    const isTemplateView = viewType === "template";
    const [viewMode, setViewMode] = useState(ClawViewMode.TESTING);
    const [taskTest, setTaskTest] = useState();
    // const [isLoading, setIsLoading] = useState(false);
    const initHelper = async () => {
        try {
            await dispatch(aibleAnywhereReducer.initClaw(agentId));
            await dispatch(chatGPTReducer.init(true));
        }
        catch (e) {
            console.log(e);
        }
        dispatch(chatGPTReducer.updateAgentId(agentId));
        const defaultTest = dispatch((dispatch, getState) => {
            const taskOptions = aibleAnywhereReducer.getClawTaskOptions(getState(), agentId);
            return taskOptions[0]?.value;
        });
        if (defaultTest?.type === "cronJobs") {
            dispatch(aibleAnywhereReducer.updateTestCronIndex(defaultTest.index));
        }
        setTaskTest(defaultTest);
        await dispatch(aibleAnywhereReducer.initClawTest(agentId, defaultTest));
    };
    useEffect(() => {
        initHelper();
    }, [match?.params?.agentId]);
    if (!clawAgent) {
        return (React.createElement("div", { className: styles.clawViewWrapper, style: { justifyContent: "center", alignItems: "center" } },
            React.createElement(LoadingIndicator, null),
            React.createElement("div", null, "Loading Agent...")));
    }
    return (React.createElement("div", { className: styles.clawViewWrapper, style: { background: "white" } },
        React.createElement("div", { className: styles.clawViewHeader },
            React.createElement("div", { className: styles.clawViewTitle }, clawAgent?.name || `${CHATAIBLE_AGENT_C.name} Agent`),
            React.createElement(ButtonGroup, { style: { marginLeft: "20px" } },
                React.createElement(Button, { onClick: () => setViewMode(ClawViewMode.TESTING), active: viewMode === ClawViewMode.TESTING }, "Test Agent"),
                React.createElement(Button, { onClick: () => setViewMode(ClawViewMode.ACTIVITY), active: viewMode === ClawViewMode.ACTIVITY }, "Activity Log"))),
        React.createElement("div", { className: styles.clawViewBody },
            React.createElement("div", { className: styles.clawViewContentWrapper },
                viewMode === ClawViewMode.MONITORING ? (React.createElement(ClawViewMonitoring, { agentId: agentId })) : viewMode === ClawViewMode.ACTIVITY ? (React.createElement(ClawViewActivity, { agentId: agentId })) : viewMode === ClawViewMode.TESTING ? (React.createElement(ClawViewTesting, { agentId: agentId, taskTest: taskTest, setTaskTest: setTaskTest })) : null,
                React.createElement(ClawViewSettings, { agentId: agentId, taskTest: taskTest, setTaskTest: setTaskTest, viewMode: viewMode, setViewMode: setViewMode, isTemplateView: isTemplateView })))));
};
const ClawViewMonitoring = ({ agentId }) => {
    return (React.createElement("div", { className: styles.clawViewContent },
        React.createElement("div", { className: styles.clawViewContentHeader }, "Analytics"),
        React.createElement("div", { className: styles.clawViewContentBody + " " + styles.clawViewContentBodyNoFooter })));
};
// Ideally we will virtualize this, so currently it's implemented as a simple table
const ClawViewActivity = ({ agentId }) => {
    const dispatch = useDispatch();
    const cActivity = useSelector((state) => aibleAnywhereReducer.getClawActivity(state, agentId));
    const cLoading = useSelector((state) => globalReducer.getClawActivityLoad(state, agentId));
    // if (cLoading) {
    //   return (
    //     <div className={styles.clawViewContent} style={{ justifyContent: "center", alignItems: "center" }}>
    //       <LoadingIndicator />
    //       <div>{"Loading Agent Activity..."}</div>
    //     </div>
    //   );
    // }
    return (React.createElement("div", { className: styles.clawViewContent },
        React.createElement("div", { className: styles.clawViewContentHeader },
            React.createElement("div", null, "Agent Activity Log"),
            React.createElement(Button, { isSmall: true, style: { padding: "6px 8px", marginLeft: "10px" }, onClick: async () => {
                    await dispatch(aibleAnywhereReducer.fetchClawActivity(agentId));
                }, disabled: cLoading },
                React.createElement(Icon, { size: 13, type: "refresh" }))),
        React.createElement("div", { className: styles.clawViewContentBody + " " + styles.clawViewContentBodyNoFooter }, cLoading ? (React.createElement("div", { className: styles.clawViewLoader },
            React.createElement(LoadingIndicator, null),
            React.createElement("div", null, "Loading Agent Activity..."))) : cActivity?.length ? (React.createElement("table", { className: styles.activityTable },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Task"),
                    React.createElement("th", null, "Time"),
                    React.createElement("th", null, "Query"),
                    React.createElement("th", null, "Response"))),
            React.createElement("tbody", null, cActivity?.map((cEntry, index) => {
                const cTask = cEntry?.name ?? "";
                const cTime = cEntry?.created_date ?? ""; // We also have access to the updated_date if we want to show when the query finished
                const cQuery = cEntry?.query ?? "";
                const cResp = cEntry?.response ?? "";
                const mTime = cTime ? moment.utc(cTime) : undefined;
                return (React.createElement("tr", { key: "activity_" + index },
                    React.createElement("td", null, cTask),
                    React.createElement("td", { title: mTime?.utcOffset(-1 * new Date().getTimezoneOffset())?.format("LLL") }, mTime?.fromNow() ?? ""),
                    React.createElement("td", null, cQuery),
                    React.createElement("td", null,
                        React.createElement(MarkdownPanel, null, cResp))));
            })))) : (React.createElement("div", null, "No Activity Detected")))));
};
const ClawViewTesting = ({ agentId, taskTest, setTaskTest }) => {
    const dispatch = useDispatch();
    const [agentPrompt, setAgentPrompt] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const cLoading = useSelector((state) => globalReducer.getClawActivityLoad(state, agentId));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const isAskingAgent = useSelector((state) => chatGPTReducer.getIsAskingAgent(state));
    const predictNextId = useSelector((state) => aibleAnywhereReducer.getPredictNextId(state));
    const hasPredictConfig = predictNextId !== undefined;
    const taskOptions = useSelector((state) => aibleAnywhereReducer.getClawTaskOptions(state, agentId));
    const selectedTask = taskTest ? taskOptions.find((o) => o.label === taskTest.name) : undefined;
    const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    const isClawAssistantTask = taskTest && taskTest?.blueprintOptions?.[0]?.workflow_plan !== undefined;
    const agent = aibleAnywhereProjects?.[agentId];
    const isAssistantAgent = agent?.isAssistant;
    const continueChat = async (task, prompt) => {
        if (task?.collection_id && !isClawAssistantTask) {
            // This doesn't have intermediate steps, but saves to activity log
            dispatch(aibleAnywhereReducer.clawChat(agentId, task?.collection_id, prompt));
        }
        else {
            // This flow doesn't save to activity log and is only used for currently not saved schedules
            let retBlueprintOptions = [...(task?.blueprintOptions ?? [])];
            if (aibleAnywhereReducer.shouldInjectSlackTool(task)) {
                retBlueprintOptions.push({
                    id: 11,
                    third_party_tool_id: task?.slackChannel?.value,
                    name: "publish_report_to_slack"
                });
            }
            if (!isEnabled("aible-claw-read-memory")) {
                retBlueprintOptions = retBlueprintOptions.filter((option) => option?.id !== "14");
            }
            if (isClawAssistantTask) {
                const workFlow = agent?.executionWorkflows?.[retBlueprintOptions?.[0]?.workflow_plan];
                return dispatch(chatGPTReducer.handleAgentIQ(prompt, false, "step-by-step", taskTest?.blueprintOptions?.[0]?.execution_id, agentId && !isNaN(Number(agentId)) ? Number(agentId) : undefined, undefined, undefined, true, workFlow));
            }
            dispatch(chatGPTReducer.handleAgentIQ(prompt, false, "reasoning", undefined, agentId && !isNaN(Number(agentId)) ? Number(agentId) : undefined, retBlueprintOptions));
        }
    };
    const handleSelectTest = async (cTest) => {
        setIsLoading(true);
        if (cTest?.collection_id !== taskTest?.collection_id) {
            setTaskTest(cTest);
            await dispatch(aibleAnywhereReducer.initClawTest(agentId, cTest));
        }
        setIsLoading(false);
    };
    const isProcessing = cLoading || isLoading;
    const disableChat = !taskTest || isProcessing;
    const disableSelect = isProcessing;
    return (React.createElement("div", { className: styles.clawViewContent, style: { border: "none", borderRadius: "none" } },
        React.createElement("div", { className: styles.clawViewContentHeader }, taskTest?.name ?? "Test Agent"),
        React.createElement("div", { className: styles.clawViewContentBody + " " + styles.testingBody }, cLoading ? (React.createElement("div", { className: styles.clawViewLoader },
            React.createElement(LoadingIndicator, null),
            React.createElement("div", null, "Loading Agent Activity..."))) : !taskTest ? (React.createElement("div", { className: styles.clawViewLoader },
            React.createElement("div", null, "Select or Create a Task to Chat"))) : (React.createElement(ChatGPT, { skipNextLoading: true, hideFooter: true, hideRightPanel: true, hideDetailsPanel: true, tryChatTemplate: !hasPredictConfig, isAssistantAgent: isAssistantAgent, style: { height: "100%" } }))),
        React.createElement("div", { className: styles.clawViewContentFooter, style: { borderTop: "none" } },
            React.createElement("div", { className: styles.clawViewContentFooterActions },
                React.createElement("div", { className: styles.clawViewFooterBox },
                    React.createElement("textarea", { className: styles.testingTextBox, value: agentPrompt, placeholder: "Enter message to chat", onChange: (e) => setAgentPrompt(e?.currentTarget?.value) }),
                    React.createElement(Button, { style: { marginLeft: "10px", float: "right" }, onClick: () => continueChat(taskTest, agentPrompt), disabled: disableChat, isLoading: isAskingAgent || isAsking, type: "primary" }, "Ask"))),
            React.createElement("div", { className: styles.clawViewContentFooterActions, style: { marginBottom: "10px", height: "40px" } },
                React.createElement("div", { style: { marginRight: "10px" } }, "Testing Task:"),
                React.createElement(Select, { className: styles.testingSelect, value: selectedTask, options: taskOptions, onChange: (val) => handleSelectTest(val.value), placeholder: "Select Task to Test", isDisabled: disableSelect, menuPlacement: "top" })))));
};
const ClawViewSettings = ({ agentId, taskTest, setTaskTest, viewMode, setViewMode, isTemplateView }) => {
    const dispatch = useDispatch();
    const [isSavingAgent, setIsSavingAgent] = useState(false);
    const [useCache, setUseCache] = useState(false);
    const savedAgent = useSelector((state) => aibleAnywhereReducer.getAibleAnywhere(state, agentId));
    const accountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    const [agent, setAgent] = useState(savedAgent);
    const [showTemplateSetup, updateShowTemplateSetup] = useState(false);
    const [hasAutoOpenedSetup, updateHasAutoOpenedSetup] = useState(false);
    const isOpenShellOrigin = agent?.workflowOrigin === "OPENSHELL";
    const isAiqOrigin = agent?.workflowOrigin === "AIQ";
    const isGeneratedWorkflow = isOpenShellOrigin || isAiqOrigin;
    const forceCronJob = async (cronJob, index) => {
        if (viewMode !== ClawViewMode.TESTING) {
            setViewMode(ClawViewMode.TESTING);
        }
        // check if it's an agent made from a project with an associated dataset to use the alt test path
        if (cronJob?.chatOverrides?.modelId &&
            cronJob?.blueprintOptions?.find((o) => o?.input_payload?.dataset_id && o?.blueprint_id)) {
            await dispatch(aibleAnywhereReducer.testCronWithDataset(cronJob));
        }
        else {
            const retType = cronJob?.type ?? "cronJobs";
            const retName = aibleAnywhereReducer.getTaskName(retType, index);
            setTaskTest({
                ...cronJob,
                name: retName,
                index: index,
                type: retType
            });
            await dispatch(aibleAnywhereReducer.testCronJob(agentId, cronJob, undefined, useCache));
        }
    };
    const forceApiInvocation = async (apiInvocation, index) => {
        if (viewMode !== ClawViewMode.TESTING) {
            setViewMode(ClawViewMode.TESTING);
        }
        const retType = apiInvocation?.type ?? "apiInvocations";
        const retName = aibleAnywhereReducer.getTaskName(retType, index);
        setTaskTest({
            ...apiInvocation,
            name: retName,
            index: index,
            type: retType
        });
        await dispatch(aibleAnywhereReducer.testApiInvocation(agentId, apiInvocation, undefined, useCache));
    };
    useEffect(() => {
        const retAgent = savedAgent ?? {
            name: "New Agent",
            isAgentC: true,
            accountId: accountId
        };
        setAgent(retAgent);
    }, [agentId]);
    useEffect(() => {
        if (isTemplateView && isGeneratedWorkflow && !hasAutoOpenedSetup) {
            updateHasAutoOpenedSetup(true);
            updateShowTemplateSetup(true);
        }
    }, [isTemplateView, isGeneratedWorkflow]);
    const hasValidAgent = aibleAnywhereReducer.isValidClawAgent(agent);
    const disableCreateAgent = !hasValidAgent;
    return (React.createElement("div", { className: styles.settingsPanel },
        React.createElement("div", { className: styles.clawViewContentHeader, style: { paddingLeft: "18px" } }, `${CHATAIBLE_AGENT_C.name} Settings`),
        isTemplateView && isOpenShellOrigin && (React.createElement("div", { className: styles.clawViewTemplateSetupButtonWrapper },
            React.createElement(Button, { type: "primary", onClick: () => updateShowTemplateSetup(true) }, "Use Template Setup"))),
        React.createElement("div", { className: styles.clawViewAgentContainer },
            React.createElement(AgentC, { agent: agent, setAgent: setAgent, forceCronTest: forceCronJob, forceAPITest: forceApiInvocation, useCache: useCache, setUseCache: setUseCache, isTemplateView: isTemplateView })),
        React.createElement("div", { className: styles.clawViewContentFooter },
            React.createElement("div", { className: styles.clawViewContentFooterActions, style: { paddingRight: "14px" } },
                React.createElement(Button, { type: "primary", style: { marginLeft: "auto" }, onClick: async () => {
                        setIsSavingAgent(true);
                        try {
                            if (isTemplateView) {
                                await dispatch(aibleAnywhereReducer.saveClawAgent(agent, agent?.name, undefined, true, true));
                            }
                            else {
                                await dispatch(aibleAnywhereReducer.saveClawAgent(agent, agent?.name));
                            }
                        }
                        catch (e) {
                            console.log(e);
                        }
                        setIsSavingAgent(false);
                    }, isLoading: isSavingAgent, disabled: disableCreateAgent }, "Save Agent"))),
        isTemplateView && isOpenShellOrigin && (React.createElement(ClawAssistantSetupModal, { showModal: showTemplateSetup, updateShowModal: updateShowTemplateSetup, agent: agent, updateAgent: setAgent }))));
};
const ClawAssistantSetupModal = ({ showModal, updateShowModal, agent, updateAgent }) => {
    const dispatch = useDispatch();
    const [isCreatingAgent, updateIsCreatingAgent] = useState(false);
    const updateSettingsByKey = (key, val) => {
        const stateUpdate = {
            ...agent,
            [key]: val
        };
        updateAgent(stateUpdate);
    };
    const handleSaveWorkflow = async () => {
        updateIsCreatingAgent(true);
        const retAgent = {
            ...agent,
            isEnabled: true
        };
        try {
            const newAgent = await dispatch(aibleAnywhereReducer.saveClawAgent(retAgent, retAgent?.name, undefined, true, true));
            updateShowModal(false);
            dispatch(viewReducer.initOpenAibleClawAgent(newAgent?.id));
        }
        catch {
            console.log("Error Saving Template:", retAgent);
        }
        finally {
            updateIsCreatingAgent(false);
        }
    };
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => updateShowModal(false) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, `${agent?.name} Setup`)),
            React.createElement(ClawAssistantSetupOptions, { agent: agent, updateAgentSettings: updateSettingsByKey }),
            React.createElement(DialogFooter, null,
                React.createElement("div", null,
                    React.createElement(Button, { type: "primary", onClick: () => {
                            handleSaveWorkflow();
                        }, isLoading: isCreatingAgent }, "Create Agent"))))));
};
const ClawAssistantSetupOptions = ({ agent, updateAgentSettings }) => {
    const assistantWorkflowPlans = useSelector((state) => aibleAnywhereReducer.getClawTaskUsedStepWorkflowsFromId(state, agent?.id, agent));
    const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    return (React.createElement("div", { className: styles.clawAssistantModalContent },
        React.createElement(StandardOptions, { sourceState: agent, updateStateByKey: updateAgentSettings }),
        React.createElement("div", { className: styles.itemCapabilitiesList },
            React.createElement("div", { className: styles.itemCapabilitiesContainer },
                "Capabilities",
                React.createElement("div", { className: styles.itemCapabilitiesList }, assistantWorkflowPlans.map((executionId) => {
                    const stepFlow = agent?.executionWorkflows?.[executionId];
                    if (!stepFlow) {
                        return null;
                    }
                    const updateWorkflow = (workflow) => {
                        const executionWorkflowsUpdate = {
                            ...(agent?.executionWorkflows ?? {}),
                            [executionId]: workflow
                        };
                        return updateAgentSettings("executionWorkflows", executionWorkflowsUpdate);
                    };
                    return (React.createElement("div", { className: styles.workflowItem },
                        React.createElement("div", { className: "font-bold" }, stepFlow?.name),
                        React.createElement(SkillsOverview, { agent: stepFlow, updateWorkflowSource: updateWorkflow, isTemplateSetup: true })));
                })))),
        React.createElement(TaggingOptions, { sourceState: agent, updateStateByKey: updateAgentSettings })));
};
export default ClawView;
